export default "__VITE_ASSET__01de02e7__"